module.exports = __webpack_public_path__ + "static/media/NonWOrdInstruction.b70ca3c1.mp3";